import { useState, FC, useEffect, useRef } from "react";
import logo from "../../../images/Damas_univ.png";
import Title from "../../Title/Title";
import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import Input from "../../Inputs/Input";

import { Bounce, toast, ToastContainer } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { useFetch, usePOST } from "../../../ApiS";
import PasswordInput from "../../Inputs/Passwordinput";
import MainButton from "../../Buttons/MainButton";
import Selected from "../../Inputs/Selected";
import AddImage from "../../../ApiS/AddImage/AddImage";
import { AxiosError } from "axios";
import Loader from "../../Loader";

interface Student {
  first_name_ar?: string;
  first_name_en?: string;
  last_name_ar?: string;
  father_name_en?: string;
  last_name_en?: string;
  father_name_ar?: string;
  mother_name_ar?: string;
  mother_name_en?: string;
  birth_place_ar?: string;
  birth_place_en?: string;
  birth_date?: string;
  nationality_id?: string;
  id_number?: number;
  gender?: string;
  place_of_registration?: string;
  national_id?: string;
  registration_number?: string;
  passport_number?: string;
  recruitment_division?: string;
  province_id?: string;
  id_university?: number;
  personal_picture?: string;
  password?: string;
  phone_number?: string;
  landline_number?: string;
  city_of_residence_id?: string;
  email?: string;
  permanent_address?: string;
  current_address?: string;
  type?: string;
  high_school_type?: string;
  high_school_certificate_source?: string;
  total_student_score?: number;
  total_certificate_score?: number;
  high_school_year?: string;
  differential_rate?: string;
  english_language_degree?: string;
  french_language_degree?: string;
  religious_education_degree?: string;
  high_school_certificate_language?: string;
  high_school_certificate_photo?: string;
  institute_name?: string;
  institute_specialization?: string;
  graduation_rate?: number;
  graduation_year?: string;
  institute_certificate_image?: string;
  institute_transcript_file?: string;
  document_decisive?: string;
  mid_name_en?: string;
  id_front_side_image?: string;
  id_back_side_image?: string;
  is_active?: string;
}
interface Error {
  first_name_ar?: string[];
  first_name_en?: string[];
  last_name_ar?: string[];
  last_name_en?: string[];
  father_name_ar?: string[];
  father_name_en?: string[];
  mother_name_ar?: string[];
  mother_name_en?: string[];
  birth_place_ar?: string[];
  birth_place_en?: string[];
  birth_date?: string[];
  nationality_id?: string[];
  id_number?: string[];
  gender?: string[];
  place_of_registration?: string[];
  national_id?: string[];
  registration_number?: string[];
  passport_number?: string[];
  recruitment_division?: string[];
  province_id?: string[];
  id_university?: string[];
  personal_picture?: string[];
  password?: string[];
  phone_number?: string[];
  landline_number?: string[];
  city_of_residence_id?: string[];
  email?: string[];
  permanent_address?: string[];
  current_address?: string[];
  type?: string[];
  high_school_type?: string[];
  high_school_certificate_source?: string[];
  total_student_score?: string[];
  total_certificate_score?: string[];
  high_school_year?: string[];
  differential_rate?: string[];
  english_language_degree?: string[];
  french_language_degree?: string[];
  religious_education_degree?: string[];
  high_school_certificate_language?: string[];
  high_school_certificate_photo?: string[];
  institute_name?: string[];
  institute_specialization?: string[];
  graduation_rate?: string[];
  graduation_year?: string[];
  institute_certificate_image?: string[];
  institute_transcript_file?: string[];
  document_decisive?: string[];
  mid_name_en?: string[];
  id_front_side_image?: string[];
  id_back_side_image?: string[];
  is_active?: string[];
}

interface StudentsData {
  data: Student;
}

const Single_Student: React.FC = () => {
  const { id } = useParams();
  const [show, setShow] = useState<number | undefined>(1);
  const [selectedOptionType, setSelectedOptionType] = useState<string>();

  // const notify = (message: string) => {
  //   toast.error(message, {
  //     position: "top-center",
  //     autoClose: 2000,
  //     hideProgressBar: false,
  //     closeOnClick: true,
  //     pauseOnHover: true,
  //     draggable: true,
  //     progress: undefined,
  //     theme: "light",
  //     transition: Bounce,
  //   });
  // };
  const navigate = useNavigate();
  const [errors, setErrors] = useState<Error>({});

  const initialData: Student = {};

  const onError = (error: AxiosError<{ errors: Error; message: string }>) => {
    toast.dismiss("loading");
    toast.error(error.response?.data?.message);
    setErrors(errors);
  };

  const {
    mutation,
    handleChangeInput,
    handleSubmit,
    setFormData,
    formData,
    viewFile,
    setViewFile,
    handleChangeSelect,
  } = usePOST(
    initialData,
    () => {
      navigate("/students");
    },

    (error) => {
      onError(error);
    }
  );

  const { data } = useFetch(`admin/nationalities`, `admin/nationalities`);

  const { data: dataProvince } = useFetch(`admin/provinces`, `admin/provinces`);

  const { data: cities } = useFetch(`admin/cities`, `admin/cities`);

  const enable = id ? true : false;

  const { data: Single_Student, isLoading } = useFetch(
    `admin/students/${id}`,
    `admin/students/${id}`,
    enable
  );

  const [personal_picture, setpersonal_picture] = useState(
    Single_Student?.data?.personal_picture
  );

  const [id_front_side_image, setid_front_side_image] = useState(
    Single_Student?.data?.id_front_side_image
  );

  const [id_back_side_image, setid_back_side_image] = useState(
    Single_Student?.data?.id_back_side_image
  );

  useEffect(() => {
    if (Single_Student?.data?.personal_picture) {
      setpersonal_picture(Single_Student?.data?.personal_picture);
    }
  }, [Single_Student?.data?.personal_picture]);

  console.log(personal_picture);

  useEffect(() => {
    if (Single_Student?.data?.id_front_side_image) {
      setid_front_side_image(Single_Student?.data?.id_front_side_image);
    }
  }, [Single_Student?.data?.id_front_side_image]);

  useEffect(() => {
    if (Single_Student?.data?.id_back_side_image) {
      setid_back_side_image(Single_Student?.data?.id_back_side_image);
    }
  }, [Single_Student?.data?.id_back_side_image]);

  const [high_school_certificate_photo, sethigh_school_certificate_photo] =
    useState(
      Single_Student?.data?.academic_info?.high_school_certificate_photo
    );
  useEffect(() => {
    if (Single_Student?.data?.academic_info?.high_school_certificate_photo) {
      sethigh_school_certificate_photo(
        Single_Student?.data?.academic_info?.high_school_certificate_photo
      );
    }
  }, [Single_Student?.data?.academic_info?.high_school_certificate_photo]);

  const [institute_certificate_image, setinstitute_certificate_image] =
    useState(Single_Student?.data?.academic_info?.institute_certificate_image);
  useEffect(() => {
    if (Single_Student?.data?.academic_info?.institute_certificate_image) {
      setinstitute_certificate_image(
        Single_Student?.data?.academic_info?.institute_certificate_image
      );
    }
  }, [Single_Student?.data?.academic_info?.institute_certificate_image]);

  const [institute_transcript_file, setinstitute_transcript_file] = useState(
    Single_Student?.data?.academic_info?.institute_transcript_file
  );
  useEffect(() => {
    if (Single_Student?.data?.academic_info?.institute_transcript_file) {
      setinstitute_transcript_file(
        Single_Student?.data?.academic_info?.institute_transcript_file
      );
    }
  }, [Single_Student?.data?.academic_info?.institute_transcript_file]);

  const [document_decisive, setdocument_decisive] = useState(
    Single_Student?.data?.academic_info?.document_decisive
  );
  useEffect(() => {
    if (Single_Student?.data?.academic_info?.document_decisive) {
      setdocument_decisive(
        Single_Student?.data?.academic_info?.document_decisive
      );
    }
  }, [Single_Student?.data?.academic_info?.document_decisive]);

  const toastId = useRef<string | number | null>(null);

  useEffect(() => {
    if (mutation.isLoading && !toast.isActive(toastId.current!)) {
      toastId.current = toast.loading("جاري التحميل...", {
        position: "bottom-left",
        autoClose: false,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
      });
    } else if (!mutation.isLoading && toastId.current && !mutation.isError) {
      toast.update(toastId.current, {
        render: "تم التحميل بنجاح!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      toastId.current = null;
    } else if (mutation.isError) {
      toast.update(toastId.current!, {
        render: id ? "هناك خطأ في عملية التعديل" : "هناك خطأ في عملية الاضافة",
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
      toastId.current = null;
    }
  }, [mutation.isLoading, mutation.isError]);

  const [confirmPassword, setConfirmPassword] = useState("");

  const validatePasswords = () => {
  
    if (formData.password || confirmPassword) {
      if (formData.password !== confirmPassword) {
        return "كلمتا المرور غير متطابقتين";
      }
    }
    return "";
  };

  const handleSubmitWithValidation = (url:any) => {
    const error = validatePasswords();
    if (error) {
      toast.error(error, {
        position: "bottom-left",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }
    handleSubmit(url);
  };

  return isLoading ? (
    <Loader />
  ) : (
    <>
      <ToastContainer position="bottom-left" />
      <Row>
        <Col>
          <Title title={`${id ? "تعديل معلومات الطالب" : " أضف طالب "}`} />
        </Col>
      </Row>
      {/* <Row>
        <Col lg={12} className="flex justify-center">
          <div>
            <img
              src={logo}
              alt="xxx"
              className="w-24 h-24 border-2 rounded-full"
            />
          </div>
        </Col>
        <Col lg={12} className="flex justify-center">
          <div className="text-lg font-bold ">أحمد الأحمد </div>
        </Col>
      </Row> */}

      <Row justify={"center"} className="!mt-5 ">
        <Col lg={10} md={10} sm={10} className="!mb-0">
          <Row className="bg-[#DDE2E4] border-2 border-[#f8f0f6] rounded-lg !h-full ">
            <Col
              lg={4}
              md={4}
              sm={4}
              className={` py-6 px-6 flex justify-center items-center  cursor-pointer !h-full show ${
                show === 1 && "bg-Secondary"
              }`}
              // onClick={() => setShow(1)}
            >
              <div className="text-base max-md:text-sm  ">
                {" "}
                المعلومات الأساسية{" "}
              </div>
            </Col>

            <Col
              lg={4}
              md={4}
              sm={4}
              className={` p-6 flex justify-center items-center  ${
                show === 3 && "bg-Secondary"
              }`}
              // onClick={() => setShow(3)}
            >
              <div className="text-base max-md:text-sm"> معلومات التواصل </div>
            </Col>

            <Col
              lg={4}
              md={4}
              sm={4}
              className={`p-6 flex justify-center items-center   ${
                show === 4 && "bg-Secondary"
              } `}
              // onClick={() => setShow(4)}
            >
              <div className="text-base max-md:text-sm">
                معلومات الشهادة الثانوية
              </div>
            </Col>
          </Row>
        </Col>

        {show === 1 && (
          <>
            <Row justify={"around"}>
              <Col lg={4} md={5} sm={11}>
                <Input
                  type="name"
                  name="first_name_ar"
                  value={formData?.first_name_ar}
                  onChange={(e) => handleChangeInput(e)}
                  title="الاسم الأول بالعربي"
                  placeholder="ادخل الأسم الأول بالعربي"
                  className="!w-full"
                  defaultValue={Single_Student?.data?.first_name_ar}
                />
                {errors?.first_name_ar &&
                  errors?.first_name_ar.map((error, index) => (
                    <p key={index} className="text-red-600 text-sm" dir="auto">
                      {error}
                    </p>
                  ))}
              </Col>

              <Col lg={4} md={5} sm={11}>
                <Input
                  type="name"
                  name="last_name_ar"
                  value={formData?.last_name_ar}
                  onChange={(e) => handleChangeInput(e)}
                  title="الاسم الاخير بالعربي"
                  placeholder="ادخل الأسم الاخير بالعربي"
                  className="!w-full"
                  defaultValue={Single_Student?.data?.last_name_ar}
                />
                {errors?.last_name_ar &&
                  errors?.last_name_ar.map((error, index) => (
                    <p key={index} className="text-red-600 text-sm" dir="auto">
                      {error}
                    </p>
                  ))}
              </Col>
              <Col lg={4} md={5} sm={11}>
                <Input
                  type="name"
                  name="father_name_ar"
                  value={formData?.father_name_ar}
                  onChange={(e) => handleChangeInput(e)}
                  title="الاسم الاب بالعربي"
                  placeholder="ادخل الاب بالعربي"
                  className="!w-full"
                  defaultValue={Single_Student?.data?.father_name_ar}
                />
                {errors?.father_name_ar &&
                  errors?.father_name_ar.map((error, index) => (
                    <p key={index} className="text-red-600 text-sm" dir="auto">
                      {error}
                    </p>
                  ))}
              </Col>

              <Col lg={4} md={5} sm={11}>
                <Input
                  type="text"
                  name="mother_name_ar"
                  value={formData?.mother_name_ar}
                  onChange={(e) => handleChangeInput(e)}
                  title="اسم الأم بالعربي"
                  placeholder="ادخل اسم الأم بالعربي"
                  className="!w-full"
                  defaultValue={Single_Student?.data?.mother_name_ar}
                />
                {errors?.mother_name_ar &&
                  errors?.mother_name_ar.map((error, index) => (
                    <p key={index} className="text-red-600 text-sm" dir="auto">
                      {error}
                    </p>
                  ))}
              </Col>

              <Col lg={4} md={5} sm={11}>
                <Input
                  type="number"
                  name="national_id"
                  value={formData?.national_id}
                  onChange={(e) => handleChangeInput(e)}
                  title="الرقم الوطني"
                  placeholder="ادخل الرقم الوطني"
                  className="!w-full"
                  defaultValue={Single_Student?.data?.national_id}
                />
                {errors?.national_id &&
                  errors?.national_id.map((error, index) => (
                    <p key={index} className="text-red-600 text-sm" dir="auto">
                      {error}
                    </p>
                  ))}
              </Col>
              <Col lg={4} md={5} sm={11}>
                <Input
                  type="text"
                  name="first_name_en"
                  value={formData?.first_name_en}
                  onChange={(e) => handleChangeInput(e)}
                  title=" الاسم الاول بالانكليزي "
                  placeholder=" الاسم الاول بالانكليزي "
                  className="!w-full"
                  defaultValue={Single_Student?.data?.first_name_en}
                />
                {errors?.first_name_en &&
                  errors?.first_name_en.map((error, index) => (
                    <p key={index} className="text-red-600 text-sm" dir="auto">
                      {error}
                    </p>
                  ))}
              </Col>

              <Col lg={4} md={5} sm={11}>
                <Input
                  type="name"
                  name="father_name_en"
                  value={formData?.father_name_en}
                  onChange={(e) => handleChangeInput(e)}
                  title="الاسم الاب بالانكليزي"
                  placeholder="ادخل الاب بالانكليزي"
                  className="!w-full"
                  defaultValue={Single_Student?.data?.father_name_en}
                />
                {errors?.father_name_en &&
                  errors?.father_name_en.map((error, index) => (
                    <p key={index} className="text-red-600 text-sm" dir="auto">
                      {error}
                    </p>
                  ))}
              </Col>

              <Col lg={4} md={5} sm={11}>
                <Input
                  type="text"
                  name="last_name_en"
                  value={formData?.last_name_en}
                  onChange={(e) => handleChangeInput(e)}
                  title=" الاسم الأخير بالانكليزي "
                  placeholder=" الاسم الأخير بالانكليزي "
                  className="!w-full"
                  defaultValue={Single_Student?.data?.last_name_en}
                />
                {errors?.last_name_en &&
                  errors?.last_name_en.map((error, index) => (
                    <p key={index} className="text-red-600 text-sm" dir="auto">
                      {error}
                    </p>
                  ))}
              </Col>
              <Col lg={4} md={5} sm={11}>
                <Input
                  type="text"
                  name="mother_name_en"
                  value={formData?.mother_name_en}
                  onChange={(e) => handleChangeInput(e)}
                  title=" اسم الام بالانكليزي "
                  placeholder=" الاسم الام بالانكليزي "
                  className="!w-full"
                  defaultValue={Single_Student?.data?.mother_name_en}
                />
                {errors?.mother_name_en &&
                  errors?.mother_name_en.map((error, index) => (
                    <p key={index} className="text-red-600 text-sm" dir="auto">
                      {error}
                    </p>
                  ))}
              </Col>
              <Col lg={4} md={5} sm={11}>
                <Input
                  type="text"
                  name="birth_place_ar"
                  value={formData?.birth_place_ar}
                  onChange={(e) => handleChangeInput(e)}
                  title=" مكان الولادة "
                  placeholder=" مكان الولادة "
                  className="!w-full"
                  defaultValue={Single_Student?.data?.birth_place_ar}
                />
                {errors?.birth_place_ar &&
                  errors?.birth_place_ar.map((error, index) => (
                    <p key={index} className="text-red-600 text-sm" dir="auto">
                      {error}
                    </p>
                  ))}
              </Col>
              <Col lg={4} md={5} sm={11}>
                <Input
                  type="text"
                  value={formData?.birth_place_en}
                  name="birth_place_en"
                  onChange={(e) => handleChangeInput(e)}
                  title="  مكان الولادة بالانكليزي"
                  placeholder=" مكان الولادة بالانكليزي"
                  className="!w-full"
                  defaultValue={Single_Student?.data?.birth_place_en}
                />
                {errors?.birth_place_en &&
                  errors?.birth_place_en.map((error, index) => (
                    <p key={index} className="text-red-600 text-sm" dir="auto">
                      {error}
                    </p>
                  ))}
              </Col>
              <Col lg={4} md={5} sm={11}>
                <Input
                  type="date"
                  name="birth_date"
                  value={formData?.birth_date}
                  onChange={(e) => handleChangeInput(e)}
                  title=" تاريخ الولادة "
                  placeholder=" تاريخ الولادة "
                  className="!w-full"
                  defaultValue={Single_Student?.data?.birth_date}
                />
                {errors?.birth_date &&
                  errors?.birth_date.map((error, index) => (
                    <p key={index} className="text-red-600 text-sm" dir="auto">
                      {error}
                    </p>
                  ))}
              </Col>

              <Col lg={4} md={5} sm={11}>
                <Selected
                  title="الجنسية"
                  value={formData?.nationality_id}
                  name="nationality_id"
                  text="أختر  الجنسية"
                  defaultValue={Single_Student?.data?.nationality_id}
                  onChange={(e) =>
                    handleChangeSelect({
                      label: e.currentTarget.name,
                      value: e.currentTarget.value,
                    })
                  }
                  className="!w-full max-lg:!w-full mb-5"
                >
                  {data?.data?.data?.map((e: any) => (
                    <option key={e.id} value={e.id}>
                      {e.ar_name}
                    </option>
                  ))}
                </Selected>
                {errors?.nationality_id &&
                  errors?.nationality_id.map((error, index) => (
                    <p key={index} className="text-red-600 text-sm" dir="auto">
                      {error}
                    </p>
                  ))}
              </Col>

              <Col lg={4} md={5} sm={11}>
                <Input
                  type="number"
                  name="id_number"
                  value={formData?.id_number}
                  defaultValue={Single_Student?.data?.id_number}
                  onChange={(e) => handleChangeInput(e)}
                  title=" رقم الهوية "
                  placeholder=" رقم الهوية "
                  className="!w-full"
                />
                {errors?.id_number &&
                  errors?.id_number.map((error, index) => (
                    <p key={index} className="text-red-600 text-sm" dir="auto">
                      {error}
                    </p>
                  ))}
              </Col>

              <Col lg={4} md={5} sm={11}>
                <Selected
                  title="الجنس"
                  value={formData?.gender}
                  name="gender"
                  text="أختر  الجنس"
                  onChange={(e) =>
                    handleChangeSelect({
                      label: e.currentTarget.name,
                      value: e.currentTarget.value,
                    })
                  }
                  defaultValue={Single_Student?.data?.gender}
                  className="!w-full max-lg:!w-full mb-5"
                >
                  <option value="male">ذكر</option>

                  <option value="female">انثى</option>
                </Selected>
                {errors?.gender &&
                  errors?.gender.map((error, index) => (
                    <p key={index} className="text-red-600 text-sm" dir="auto">
                      {error}
                    </p>
                  ))}
              </Col>
              <Col lg={4} md={5} sm={11}>
                <Input
                  type="text"
                  name="place_of_registration"
                  onChange={(e) => handleChangeInput(e)}
                  title=" مكان الاقامة "
                  placeholder=" مكان الاقامة "
                  className="!w-full"
                  value={formData?.place_of_registration}
                  defaultValue={Single_Student?.data?.place_of_registration}
                />
                {errors?.place_of_registration &&
                  errors?.place_of_registration.map((error, index) => (
                    <p key={index} className="text-red-600 text-sm" dir="auto">
                      {error}
                    </p>
                  ))}
              </Col>

              <Col lg={4} md={5} sm={11}>
                <Input
                  type="number"
                  name="registration_number"
                  onChange={(e) => handleChangeInput(e)}
                  title=" رقم القيد "
                  placeholder=" رقم القيد "
                  className="!w-full"
                  value={formData?.registration_number}
                  defaultValue={Single_Student?.data?.registration_number}
                />
                {errors?.registration_number &&
                  errors?.registration_number.map((error, index) => (
                    <p key={index} className="text-red-600 text-sm" dir="auto">
                      {error}
                    </p>
                  ))}
              </Col>

              <Col lg={4} md={5} sm={11}>
                <Input
                  type="text"
                  name="passport_number"
                  onChange={(e) => handleChangeInput(e)}
                  title=" رقم جواز السفر "
                  placeholder=" رقم جواز السفر "
                  className="!w-full"
                  value={formData?.passport_number}
                  defaultValue={Single_Student?.data?.passport_number}
                />
                {errors?.passport_number &&
                  errors?.passport_number.map((error, index) => (
                    <p key={index} className="text-red-600 text-sm" dir="auto">
                      {error}
                    </p>
                  ))}
              </Col>
              <Col lg={4} md={5} sm={11}>
                <Input
                  type="text"
                  name="recruitment_division"
                  onChange={(e) => handleChangeInput(e)}
                  title=" شعبة التجنيد  "
                  placeholder=" شعبة التجنيد "
                  className="!w-full"
                  value={formData?.recruitment_division}
                  defaultValue={Single_Student?.data?.recruitment_division}
                />
                {errors?.recruitment_division &&
                  errors?.recruitment_division.map((error, index) => (
                    <p key={index} className="text-red-600 text-sm" dir="auto">
                      {error}
                    </p>
                  ))}
              </Col>

              <Col lg={4} md={5} sm={11}>
                <Selected
                  title="المحافظة"
                  name="province_id"
                  text="أختر المحافظة"
                  value={formData?.province_id}
                  onChange={(e) =>
                    handleChangeSelect({
                      label: e.currentTarget.name,
                      value: e.currentTarget.value,
                    })
                  }
                  className="!w-full max-lg:!w-full mb-5"
                  defaultValue={Single_Student?.data?.province_id}
                >
                  {dataProvince?.data?.data?.map((e: any) => (
                    <option key={e.id} value={e.id}>
                      {e.ar_name}
                    </option>
                  ))}
                </Selected>
                {errors?.province_id &&
                  errors?.province_id.map((error, index) => (
                    <p key={index} className="text-red-600 text-sm" dir="auto">
                      {error}
                    </p>
                  ))}
              </Col>

              <Col lg={4} md={5} sm={11}>
                <Input
                  type="number"
                  name="id_university"
                  onChange={(e) => handleChangeInput(e)}
                  title=" الرقم الجامعي   "
                  placeholder=" الرقم الجامعي "
                  className="!w-full"
                  value={formData?.id_university}
                  defaultValue={Single_Student?.data?.university_id}
                />
                {errors?.id_university &&
                  errors?.id_university.map((error, index) => (
                    <p key={index} className="text-red-600 text-sm" dir="auto">
                      {error}
                    </p>
                  ))}
              </Col>

              <Col lg={4} md={5} sm={11}>
                <h1 className="mb-4 text-lg text-Dark font-bold">
                  أضف صورة الشخصية
                </h1>
                <AddImage
                  type="IMAGE"
                  id="personal_picture"
                  title="أضف الصورة الشخصية  "
                  name="personal_picture"
                  onChange={(event) =>
                    handleChangeInput(event, "personal_picture")
                  }
                  oldImage={personal_picture}
                  newImage={viewFile["personal_picture"]?.image}
                  clickDeleteImage={() => {
                    setViewFile((prev) => ({
                      ...prev,
                      personal_picture: { image: "" },
                    }));
                    setFormData((prev) => ({
                      ...prev,
                      personal_picture: "",
                    }));
                  }}
                  clickDeleteOldImage={() => {
                    setpersonal_picture(null);
                  }}
                />
                {errors?.personal_picture &&
                  errors?.personal_picture.map((error, index) => (
                    <p key={index} className="text-red-600 text-sm" dir="auto">
                      {error}
                    </p>
                  ))}
              </Col>
              <Col lg={4} md={5} sm={11}>
                <h1 className="mb-4 text-lg text-Dark font-bold">
                  أضف صورة الوجه الامامي للهوية الشخصية
                </h1>
                <AddImage
                  type="IMAGE"
                  id="id_front_side_image"
                  title="أضف صورة الوجه الامامي للهوية الشخصية"
                  name="id_front_side_image"
                  onChange={(event) =>
                    handleChangeInput(event, "id_front_side_image")
                  }
                  oldImage={id_front_side_image}
                  newImage={viewFile["id_front_side_image"]?.image}
                  clickDeleteImage={() => {
                    setViewFile((prev) => ({
                      ...prev,
                      id_front_side_image: { image: "" },
                    }));
                    setFormData((prev) => ({
                      ...prev,
                      id_front_side_image: "",
                    }));
                  }}
                  clickDeleteOldImage={() => {
                    setid_front_side_image(null);
                  }}
                />
                {errors?.id_front_side_image &&
                  errors?.id_front_side_image.map((error, index) => (
                    <p key={index} className="text-red-600 text-sm" dir="auto">
                      {error}
                    </p>
                  ))}
              </Col>
              <Col lg={4} md={5} sm={11}>
                <h1 className="mb-4 text-lg text-Dark font-bold">
                  أضف صورة الوجه الخلفي للهوية الشخصية
                </h1>
                <AddImage
                  type="IMAGE"
                  id="id_back_side_image"
                  title="أضف صورة الوجه الخلفي للهوية الشخصية"
                  name="id_back_side_image"
                  onChange={(event) =>
                    handleChangeInput(event, "id_back_side_image")
                  }
                  oldImage={id_back_side_image}
                  newImage={viewFile["id_back_side_image"]?.image}
                  clickDeleteImage={() => {
                    setViewFile((prev) => ({
                      ...prev,
                      id_back_side_image: { image: "" },
                    }));
                    setFormData((prev) => ({
                      ...prev,
                      id_back_side_image: "",
                    }));
                  }}
                  clickDeleteOldImage={() => {
                    setid_back_side_image(null);
                  }}
                />
                {errors?.id_back_side_image &&
                  errors?.id_back_side_image.map((error, index) => (
                    <p key={index} className="text-red-600 text-sm" dir="auto">
                      {error}
                    </p>
                  ))}
              </Col>

              <Col lg={4} md={5} sm={11}>
                <Input
                  type="text"
                  name="password"
                  onChange={(e) => handleChangeInput(e)}
                  title=" كلمة المرور "
                  placeholder=" كلمة المرور "
                  className="!w-full"
                  value={formData?.password}
                  defaultValue={Single_Student?.data?.password}
                />
                {errors?.password &&
                  errors?.password.map((error, index) => (
                    <p key={index} className="text-red-600 text-sm" dir="auto">
                      {error}
                    </p>
                  ))}
              </Col>
              <Col lg={4} md={5} sm={11}>
                <Input
                  type="text"
                  name="confirmPassword"
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  title="تأكيد كلمة المرور" 
                  placeholder="تأكيد كلمة المرور"
                  className="!w-full"
                  value={confirmPassword}
                />

              </Col>
              <Col lg={4} md={5} sm={11}>
                <Selected
                  title="حالة الحساب "
                  name="is_active"
                  text=" حالة الحساب "
                  value={formData?.is_active}
                  onChange={(e) =>
                    handleChangeSelect({
                      label: e.currentTarget.name,
                      value: e.currentTarget.value,
                    })
                  }
                  className="!w-full max-lg:!w-full mb-5"
                  defaultValue={Single_Student?.data?.is_active}
                >
                  <option value="1">فعال</option>

                  <option value="0">غير فعال</option>
                </Selected>
                {errors?.is_active &&
                  errors?.is_active.map((error, index) => (
                    <p key={index} className="text-red-600 text-sm" dir="auto">
                      {error}
                    </p>
                  ))}
              </Col>
            </Row>
            <Col
              lg={11}
              md={5}
              sm={11}
              className="flex lg:justify-center max-lg:mx-auto  !mt-4 "
            >
              <MainButton
                onClick={() => setShow(3)}
                titlebtn="التالي"
                className="lg:w-[400px] md:w-[300px] max-md:w-[275px] "
              />
            </Col>
          </>
        )}

        {show === 3 && (
          <Row justify={"around"}>
            <Col lg={4} md={5} sm={11}>
              <Input
                placeholder="رقم الموبايل"
                title="رقم الموبايل"
                className="!bg-white !border-2 border-Secondary"
                name="phone_number"
                onChange={(e) => handleChangeInput(e)}
                value={formData?.phone_number}
                defaultValue={Single_Student?.data?.contact_info?.phone_number}
              />
              {errors?.phone_number &&
                errors?.phone_number.map((error, index) => (
                  <p key={index} className="text-red-600 text-sm" dir="auto">
                    {error}
                  </p>
                ))}
            </Col>
            <Col lg={4} md={5} sm={11}>
              <Input
                placeholder=" رقم الهاتف "
                title=" رقم الهاتف "
                className="!bg-white !border-2 border-Secondary"
                name="landline_number"
                onChange={(e) => handleChangeInput(e)}
                value={formData?.landline_number}
                defaultValue={
                  Single_Student?.data?.contact_info?.landline_number
                }
              />
              {errors?.landline_number &&
                errors?.landline_number.map((error, index) => (
                  <p key={index} className="text-red-600 text-sm" dir="auto">
                    {error}
                  </p>
                ))}
            </Col>
            <Col lg={4} md={5} sm={11}>
              <Selected
                title="بلد الاقامة"
                value={formData?.city_of_residence_id}
                name="city_of_residence_id"
                text="أختر  البلد"
                onChange={(e) =>
                  handleChangeSelect({
                    label: e.currentTarget.name,
                    value: e.currentTarget.value,
                  })
                }
                className="!w-full max-lg:!w-full mb-5"
                defaultValue={
                  Single_Student?.data?.contact_info?.city_of_residence?.id
                }
              >
                {cities?.data?.map((e: any) => (
                  <option value={e.id}>{e.name_ar}</option>
                ))}
              </Selected>
              {errors?.city_of_residence_id &&
                errors?.city_of_residence_id.map((error, index) => (
                  <p key={index} className="text-red-600 text-sm" dir="auto">
                    {error}
                  </p>
                ))}
            </Col>
            <Col lg={4} md={5} sm={11}>
              <Input
                placeholder=" الأيميل "
                title=" الأيميل "
                className="!bg-white !border-2 border-Secondary !mt-3"
                name="email"
                onChange={(e) => handleChangeInput(e)}
                value={formData?.email}
                defaultValue={Single_Student?.data?.contact_info?.email}
              />
              {errors?.email &&
                errors?.email.map((error, index) => (
                  <p key={index} className="text-red-600 text-sm" dir="auto">
                    {error}
                  </p>
                ))}
            </Col>

            <Col lg={4} md={5} sm={11}>
              <Input
                name="permanent_address"
                placeholder=" العنوان الدائم "
                title=" العنوان الدائم "
                className="!bg-white !border-2 border-Secondary"
                onChange={(e) => handleChangeInput(e)}
                value={formData?.permanent_address}
                defaultValue={
                  Single_Student?.data?.contact_info?.permanent_address
                }
              />
              {errors?.permanent_address &&
                errors?.permanent_address.map((error, index) => (
                  <p key={index} className="text-red-600 text-sm" dir="auto">
                    {error}
                  </p>
                ))}
            </Col>
            <Col lg={4} md={5} sm={11}>
              <Input
                placeholder="العنوان الحالي"
                title="العنوان الحالي"
                className="!bg-white !border-2 border-Secondary"
                name="current_address"
                onChange={(e) => handleChangeInput(e)}
                value={formData?.current_address}
                defaultValue={
                  Single_Student?.data?.contact_info?.current_address
                }
              />
              {errors?.current_address &&
                errors?.current_address.map((error, index) => (
                  <p key={index} className="text-red-600 text-sm" dir="auto">
                    {error}
                  </p>
                ))}
            </Col>
            <Col
              lg={4}
              md={5}
              sm={5}
              className="flex lg:justify-center max-lg:mx-auto  !mt-4 "
            >
              <MainButton
                onClick={() => setShow(1)}
                titlebtn="السابق"
                className="lg:w-[400px] md:w-[300px] max-md:w-[130px] "
              />
            </Col>
            <Col
              lg={4}
              md={5}
              sm={5}
              className="flex lg:justify-center max-lg:mx-auto  !mt-4 "
            >
              <MainButton
                onClick={() => setShow(4)}
                titlebtn="التالي"
                className="lg:w-[400px] md:w-[300px] max-md:w-[130px] "
              />
            </Col>
          </Row>
        )}

        {show === 4 && (
          <Row justify={"around"}>
            <Col lg={5} md={5} sm={11}>
              <Selected
                title="النوع "
                value={formData?.type}
                name="type"
                text="أختر  النوع"
                onChange={(e) =>
                  handleChangeSelect({
                    label: e.currentTarget.name,
                    value: e.currentTarget.value,
                  })
                }
                className="!w-full max-lg:!w-full mb-5"
                defaultValue={Single_Student?.data?.academic_info?.type}
              >
                <option value="Institute_and_high_school">معهد و ثانوية</option>

                <option value="High_school">ثانوية</option>
              </Selected>
              {errors?.type &&
                errors?.type.map((error, index) => (
                  <p key={index} className="text-red-600 text-sm" dir="auto">
                    {error}
                  </p>
                ))}
            </Col>

            <Col lg={4} md={5} sm={11}>
              <Selected
                title="نوع الثانوية "
                value={formData?.high_school_type}
                name="high_school_type"
                text="أختر  نوع الثانوية"
                onChange={(e) =>
                  handleChangeSelect({
                    label: e.currentTarget.name,
                    value: e.currentTarget.value,
                  })
                }
                className="!w-full max-lg:!w-full mb-5"
                defaultValue={
                  Single_Student?.data?.academic_info?.high_school_type
                }
              >
                <option value="scientific">علمي</option>

                <option value="legitimate">شرعي</option>
              </Selected>
              {errors?.high_school_type &&
                errors?.high_school_type.map((error, index) => (
                  <p key={index} className="text-red-600 text-sm" dir="auto">
                    {error}
                  </p>
                ))}
            </Col>
            <Col lg={4} md={5} sm={11}>
              <Input
                placeholder=" مصدر الشهادة الثانوية العامة "
                title=" مصدر الشهادة الثانوية العامة "
                className="!bg-white !border-2 border-Secondary"
                name="high_school_certificate_source"
                onChange={(e) => handleChangeInput(e)}
                value={formData?.high_school_certificate_source}
                defaultValue={
                  Single_Student?.data?.academic_info
                    ?.high_school_certificate_source
                }
              />
              {errors?.high_school_certificate_source &&
                errors?.high_school_certificate_source.map((error, index) => (
                  <p key={index} className="text-red-600 text-sm" dir="auto">
                    {error}
                  </p>
                ))}
            </Col>
            <Col lg={4} md={5} sm={11}>
              <Input
                type="number"
                name="total_student_score"
                placeholder=" مجموع درجات الطالب "
                title=" مجموع درجات الطالب "
                className="!bg-white !border-2 border-Secondary"
                onChange={(e) => handleChangeInput(e)}
                value={formData?.total_student_score}
                defaultValue={
                  Single_Student?.data?.academic_info?.total_student_score
                }
              />
              {errors?.total_student_score &&
                errors?.total_student_score.map((error, index) => (
                  <p key={index} className="text-red-600 text-sm" dir="auto">
                    {error}
                  </p>
                ))}
            </Col>
            <Col lg={4} md={5} sm={11}>
              <Input
                type="number"
                name="total_certificate_score"
                placeholder=" مجموع_درجات_الشهادة "
                title=" مجموع_درجات_الشهادة "
                className="!bg-white !border-2 border-Secondary"
                onChange={(e) => handleChangeInput(e)}
                value={formData?.total_certificate_score}
                defaultValue={
                  Single_Student?.data?.academic_info?.total_certificate_score
                }
              />
              {errors?.total_certificate_score &&
                errors?.total_certificate_score.map((error, index) => (
                  <p key={index} className="text-red-600 text-sm" dir="auto">
                    {error}
                  </p>
                ))}
            </Col>
            <Col lg={4} md={5} sm={11}>
              <Input
                type="date"
                name="high_school_year"
                placeholder="  سنة ثانوية"
                title="  سنة ثانوية"
                className="!bg-white !border-2 border-Secondary"
                onChange={(e) => handleChangeInput(e)}
                value={formData?.high_school_year}
                defaultValue={
                  Single_Student?.data?.academic_info?.high_school_year
                }
              />
              {errors?.high_school_year &&
                errors?.high_school_year.map((error, index) => (
                  <p key={index} className="text-red-600 text-sm" dir="auto">
                    {error}
                  </p>
                ))}
            </Col>

            <Col lg={4} md={5} sm={11}>
              <Input
                name="differential_rate"
                placeholder="   معدل التفاضل"
                title="   معدل التفاضل"
                className="!bg-white !border-2 border-Secondary"
                onChange={(e) => handleChangeInput(e)}
                value={formData?.differential_rate}
                defaultValue={
                  Single_Student?.data?.academic_info?.differential_rate
                }
              />
              {errors?.differential_rate &&
                errors?.differential_rate.map((error, index) => (
                  <p key={index} className="text-red-600 text-sm" dir="auto">
                    {error}
                  </p>
                ))}
            </Col>
            <Col lg={4} md={5} sm={11}>
              <Input
                name="english_language_degree"
                placeholder=" درجة اللغة الإنجليزية "
                title=" درجة اللغة الإنجليزية "
                className="!bg-white !border-2 border-Secondary"
                onChange={(e) => handleChangeInput(e)}
                value={formData?.english_language_degree}
                defaultValue={
                  Single_Student?.data?.academic_info?.english_language_degree
                }
              />
              {errors?.english_language_degree &&
                errors?.english_language_degree.map((error, index) => (
                  <p key={index} className="text-red-600 text-sm" dir="auto">
                    {error}
                  </p>
                ))}
            </Col>
            <Col lg={4} md={5} sm={11}>
              <Input
                name="french_language_degree"
                placeholder=" درجة اللغة الفرنسية "
                title=" درجة اللغة الفرنسية "
                className="!bg-white !border-2 border-Secondary"
                onChange={(e) => handleChangeInput(e)}
                value={formData?.french_language_degree}
                defaultValue={
                  Single_Student?.data?.academic_info?.french_language_degree
                }
              />
              {errors?.french_language_degree &&
                errors?.french_language_degree.map((error, index) => (
                  <p key={index} className="text-red-600 text-sm" dir="auto">
                    {error}
                  </p>
                ))}
            </Col>
            <Col lg={4} md={5} sm={11}>
              <Input
                name="religious_education_degree"
                placeholder=" درجة_التعليم_الديني "
                title=" درجة_التعليم_الديني "
                className="!bg-white !border-2 border-Secondary"
                onChange={(e) => handleChangeInput(e)}
                value={formData?.religious_education_degree}
                defaultValue={
                  Single_Student?.data?.academic_info
                    ?.religious_education_degree
                }
              />
              {errors?.religious_education_degree &&
                errors?.religious_education_degree.map((error, index) => (
                  <p key={index} className="text-red-600 text-sm" dir="auto">
                    {error}
                  </p>
                ))}
            </Col>
            <Col lg={4} md={5} sm={11}>
              <Selected
                title="لغة شهادة الثانوية العامة "
                value={formData?.high_school_certificate_language}
                name="high_school_certificate_language"
                text="  لغة شهادة الثانوية العامة"
                onChange={(e) =>
                  handleChangeSelect({
                    label: e.currentTarget.name,
                    value: e.currentTarget.value,
                  })
                }
                className="!w-full max-lg:!w-full mb-5"
                defaultValue={
                  Single_Student?.data?.academic_info
                    ?.high_school_certificate_language
                }
              >
                <option value="english"> انكليزي </option>

                <option value="french">فرنسي</option>
              </Selected>
              {errors?.high_school_certificate_language &&
                errors?.high_school_certificate_language.map((error, index) => (
                  <p key={index} className="text-red-600 text-sm" dir="auto">
                    {error}
                  </p>
                ))}
            </Col>

            <Col lg={4} md={5} sm={11}>
              <h1 className="mb-4 text-lg text-Dark font-bold">
                صورة شهادة الثانوية العامة
              </h1>
              <AddImage
                type="IMAGE"
                id="high_school_certificate_photo"
                title="  صورة شهادة الثانوية العامة"
                name="high_school_certificate_photo"
                onChange={(event) =>
                  handleChangeInput(event, "high_school_certificate_photo")
                }
                oldImage={high_school_certificate_photo}
                newImage={viewFile["high_school_certificate_photo"]?.image}
                clickDeleteImage={() => {
                  setViewFile((prev) => ({
                    ...prev,
                    high_school_certificate_photo: { image: "" },
                  }));
                  setFormData((prev) => ({
                    ...prev,
                    high_school_certificate_photo: "",
                  }));
                }}
                clickDeleteOldImage={() => {
                  sethigh_school_certificate_photo(null);
                }}
              />
              {errors?.high_school_certificate_photo &&
                errors?.high_school_certificate_photo.map((error, index) => (
                  <p key={index} className="text-red-600 text-sm" dir="auto">
                    {error}
                  </p>
                ))}
            </Col>

            <Col lg={4} md={5} sm={11}>
              <Input
                name="institute_name"
                placeholder="اسم المعهد"
                title="اسم المعهد"
                className="!bg-white !border-2 border-Secondary"
                onChange={(e) => handleChangeInput(e)}
                value={formData?.institute_name}
                defaultValue={
                  Single_Student?.data?.academic_info?.institute_name
                }
              />
              {errors?.institute_name &&
                errors?.institute_name.map((error, index) => (
                  <p key={index} className="text-red-600 text-sm" dir="auto">
                    {error}
                  </p>
                ))}
            </Col>
            <Col lg={4} md={5} sm={11}>
              <Input
                name="institute_specialization"
                placeholder="تخصص المعهد"
                title="تخصص المعهد"
                className="!bg-white !border-2 border-Secondary"
                onChange={(e) => handleChangeInput(e)}
                value={formData?.institute_specialization}
                defaultValue={
                  Single_Student?.data?.academic_info?.institute_specialization
                }
              />
              {errors?.institute_specialization &&
                errors?.institute_specialization.map((error, index) => (
                  <p key={index} className="text-red-600 text-sm" dir="auto">
                    {error}
                  </p>
                ))}
            </Col>
            <Col lg={4} md={5} sm={11}>
              <Input
                type="number"
                name="graduation_rate"
                placeholder=" معدل التخرج"
                title=" معدل التخرج"
                className="!bg-white !border-2 border-Secondary"
                onChange={(e) => handleChangeInput(e)}
                value={formData?.graduation_rate}
                defaultValue={
                  Single_Student?.data?.academic_info?.graduation_rate
                }
              />
              {errors?.graduation_rate &&
                errors?.graduation_rate.map((error, index) => (
                  <p key={index} className="text-red-600 text-sm" dir="auto">
                    {error}
                  </p>
                ))}
            </Col>
            <Col lg={4} md={5} sm={11}>
              <Input
                type="date"
                name="graduation_year"
                placeholder=" عام التخرج"
                title=" عام التخرج"
                className="!bg-white !border-2 border-Secondary"
                onChange={(e) => handleChangeInput(e)}
                value={formData?.graduation_year}
                defaultValue={
                  Single_Student?.data?.academic_info?.graduation_year
                }
              />
              {errors?.graduation_year &&
                errors?.graduation_year.map((error, index) => (
                  <p key={index} className="text-red-600 text-sm" dir="auto">
                    {error}
                  </p>
                ))}
            </Col>
            <Col lg={4} md={5} sm={11}>
              <h1 className="mb-4 text-lg text-Dark font-bold">
                صورة شهادة المعهد
              </h1>
              <AddImage
                type="IMAGE"
                id="institute_certificate_image"
                title="  صورة شهادة المعهد"
                name="institute_certificate_image"
                onChange={(event) =>
                  handleChangeInput(event, "institute_certificate_image")
                }
                oldImage={institute_certificate_image}
                newImage={viewFile["institute_certificate_image"]?.image}
                clickDeleteImage={() => {
                  setViewFile((prev) => ({
                    ...prev,
                    institute_certificate_image: { image: "" },
                  }));
                  setFormData((prev) => ({
                    ...prev,
                    institute_certificate_image: "",
                  }));
                }}
                clickDeleteOldImage={() => {
                  setinstitute_certificate_image(null);
                }}
              />
              {errors?.institute_certificate_image &&
                errors?.institute_certificate_image.map((error, index) => (
                  <p key={index} className="text-red-600 text-sm" dir="auto">
                    {error}
                  </p>
                ))}
            </Col>
            <Col lg={4} md={5} sm={11}>
              <h1 className="mb-4 text-lg text-Dark font-bold">
                ملف نسخة المعهد
              </h1>
              <AddImage
                type="PDF"
                id="institute_transcript_file"
                title="   ملف نسخة المعهد "
                name="institute_transcript_file"
                onChange={(event) =>
                  handleChangeInput(event, "institute_transcript_file")
                }
                oldPDF={institute_transcript_file}
                newPDF={viewFile["institute_transcript_file"]?.pdf}
                clickDeletePDF={() => {
                  setViewFile((prev) => ({
                    ...prev,
                    institute_transcript_file: { pdf: "" },
                  }));
                  setFormData((prev) => ({
                    ...prev,
                    institute_transcript_file: "",
                  }));
                }}
                clickDeleteOldPDF={() => {
                  setinstitute_transcript_file(null);
                }}
              />
              {errors?.institute_transcript_file &&
                errors?.institute_transcript_file.map((error, index) => (
                  <p key={index} className="text-red-600 text-sm" dir="auto">
                    {error}
                  </p>
                ))}
            </Col>
            <Col lg={4} md={5} sm={11}>
              <h1 className="mb-4 text-lg text-Dark font-bold">وثيقة الحسم</h1>
              <AddImage
                type="PDF"
                id="document_decisive"
                title="   وثيقة الحسم"
                name="document_decisive"
                onChange={(event) =>
                  handleChangeInput(event, "document_decisive")
                }
                oldPDF={document_decisive}
                newPDF={viewFile["document_decisive"]?.pdf}
                clickDeletePDF={() => {
                  setViewFile((prev) => ({
                    ...prev,
                    document_decisive: { pdf: "" },
                  }));
                  setFormData((prev) => ({
                    ...prev,
                    document_decisive: "",
                  }));
                }}
                clickDeleteOldPDF={() => {
                  setdocument_decisive(null);
                }}
              />
            </Col>
            <Col lg={4} md={5} sm={11}></Col>

            <Col
              lg={5}
              md={5}
              sm={5}
              className="flex lg:justify-center max-lg:mx-auto  !mt-4 "
            >
              <MainButton
                onClick={() => setShow(3)}
                titlebtn="السابق"
                className="lg:w-[400px] md:w-[300px] max-md:w-[130px] "
              />
            </Col>
            <Col
              lg={5}
              md={5}
              sm={5}
              className="flex lg:justify-center max-lg:mx-auto  !mt-4 "
            >
              <MainButton
                onClick={() =>
                  handleSubmitWithValidation(
                    `${id ? `admin/students/${id}?_method=PUT` : "admin/students"}`
                  )
                }
                titlebtn={id ? "تعديل" : "انشاء"}
                className={`lg:w-[400px] md:w-[300px] max-md:w-[130px] ${
                  mutation.isLoading && "cursor-not-allowed"
                }`}
                disabled={mutation.isLoading}
              />
            </Col>
          </Row>
        )}

        {show === 5 && (
          <Col
            lg={10}
            md={10}
            sm={10}
            className="border-2 border-t-0 !px-4 !py-4"
          >
            <Row>
              <Col lg={2} className="flex justify-center">
                <img src={logo} className="rounded-full w-[100px] h-[100px]" />
              </Col>
              <Col lg={2} className="flex items-center">
                <h1 className="text-2xl font-bold max-lg:mx-auto">
                  اسم الدكتور
                </h1>
              </Col>
            </Row>
            <Row justify={"center"} className="!mt-5">
              <Col
                lg={3}
                md={5}
                className="mx-5 border-2 p-4 flex items-center"
              >
                <div className="mx-5 text-base">
                  <div className="pb-4">المرتبة العلمية</div>
                  <div className="pb-4">رقم الموبايل</div>
                  <div className="pb-2">البريد الالكتروني</div>
                </div>
              </Col>

              <Col
                lg={3}
                md={5}
                className="mx-5 border-2 p-4 flex items-center"
              >
                <div className="mx-5 text-base">
                  <div className="pb-4">المرتبة العلمية</div>
                  <div className="pb-4">رقم الموبايل</div>
                  <div className="pb-2">البريد الالكتروني</div>
                </div>
              </Col>

              <Col lg={3} md={5} className="mx-5 border-2 p-4">
                <div className="mx-5 text-base">
                  <div className="pb-4 text-Secondary">
                    اسماء المؤلفات العلمية
                  </div>
                  <div className="pb-4">المرتبة العلمية</div>
                  <div className="pb-4">رقم الموبايل</div>
                  <div className="pb-2">البريد الالكتروني</div>
                </div>
              </Col>

              <Col lg={3} md={5} className="mx-5 border-2 p-4">
                <div className="mx-5 text-base">
                  <div className="pb-4 text-Secondary">
                    اسماء الأبحاث العلمية
                  </div>
                  <div className="pb-4"> عنوان البحث</div>
                  <div className="pb-4"> اسم المجلة العلمية</div>
                  <div className="pb-4"> رقم العدد</div>
                  <div className="pb-4"> سنة النشر </div>
                </div>
              </Col>

              <Col lg={3} md={5} className="mx-5 border-2 p-4">
                <div className="mx-5 text-base">
                  <div className="pb-4 text-Secondary">
                    {" "}
                    اسماء المقررات التي يدرسها
                  </div>
                  <div className="pb-4"> اسم المقرر</div>
                  <div className="pb-4"> اسم المقرر</div>
                  <div className="pb-4"> اسم المقرر</div>
                  <div className="pb-4"> اسم المقرر</div>
                </div>
              </Col>

              <Col lg={3} md={5} className="mx-5 border-2 p-4">
                <div className="mx-5 text-base">
                  <div className="pb-4 text-Secondary"> الخبرات الاكاديمية</div>
                  <div className="pb-4"> الخبرات</div>
                  <div className="pb-4"> الخبرات</div>
                  <div className="pb-4"> الخبرات</div>
                  <div className="pb-4"> الخبرات</div>
                </div>
              </Col>
            </Row>
          </Col>
        )}
      </Row>
    </>
  );
};

export default Single_Student;
